































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateCourt from "./create-court.vue";
import EditCourt from "./edit-court.vue";
import CreateClosure from "../closure/create-closure.vue";
import Ajax from "../../lib/ajax";
import RegionSelect from "../../components/region-select.vue";
class PageCourtRequest extends PageRequest {
  name: string;
  regionId: number = null;
  isActive: boolean = true;
  isClose: boolean = false;
  isBack: boolean = true;
  isShowVipPrice: boolean | null;
}

@Component({
  components: { CreateCourt, EditCourt, RegionSelect, CreateClosure },
})
export default class Courts extends AbpBase {
  // 编辑按钮事件处理
  edit(row) {
    this.$store.commit("court/edit", row);
    this.editModalShow = true;
  }
  //请求过滤参数
  pagerequest: PageCourtRequest = new PageCourtRequest();

  createModalShow: boolean = false;
  editModalShow: boolean = false;

  createCourtId: number = null;
  createClosureModalShow: boolean = false;

  regions = [];

  selectedRegions = [];

  get list() {
    return this.$store.state.court.list;
  }
  get loading() {
    return this.$store.state.court.loading;
  }
  create() {
    this.createModalShow = true;
  }

  pageChange(page: number) {
    this.$store.commit("court/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("court/setPageSize", pagesize);
    this.getpage();
  }
  search() {
    this.$store.commit("court/setCurrentPage", 1);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    this.pagerequest.isActive = !this.pagerequest.isClose;
    //filters

    await this.$store.dispatch({
      type: "court/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.court.pageSize;
  }
  get totalCount() {
    return this.$store.state.court.totalCount;
  }
  get currentPage() {
    return this.$store.state.court.currentPage;
  }
  updateDisplayOrder(row) {
    Ajax.put("/api/services/app/Court/UpdateCourtDisplayOrder", {
      id: row.id,
      displayOrder: row.displayOrder,
    });
  }
  menuClick(name, row) {
    console.log(row, "row");
    switch (name) {
      case "edit":
        this.edit(row);
        break;
      case "delete":
        this.$Modal.confirm({
          title: this.L("Tips"),
          content: this.L("CourtDeleteWarningMessage"),
          okText: this.L("Yes"),
          cancelText: this.L("No"),
          onOk: async () => {
            await this.$store.dispatch({
              type: "court/delete",
              data: row,
            });
            await this.getpage();
          },
        });
        break;
      case "disable":
        this.changeActive(row, false);
        break;
      case "enable":
        this.changeActive(row, true);
        break;
      case "disablePreferential":
        this.changePreferential(row, false);
        break;
      case "enablePreferential":
        this.changePreferential(row, true);
        break;
      case "createClosure":
        this.createCourtId = row.id;
        this.createClosureModalShow = true;
        break;
      default:
        break;
    }
  }
  async changeActive(row, pass: boolean) {
    this.$store.commit("court/changeLoading", true);
    await Ajax.put("/api/services/app/Court/UpdateCourtActiveState", {
      id: row.id,
      isActive: pass,
    });
    await this.getpage();
    this.$store.commit("court/changeLoading", false);
  }
  async changePreferential(row, pass: boolean) {
    this.$store.commit("court/changeLoading", true);
    await Ajax.put("/api/services/app/Court/UpdateCourtPreferential", {
      id: row.id,
      isPreferential: pass,
    });
    await this.getpage();
    this.$store.commit("court/changeLoading", false);
  }
  columns = [
    {
      title: this.L("CourtName"),
      key: "name",
      tooltip: true,
    },
    {
      title: "英文名称",
      key: "englishName",
      tooltip: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.englishName ? params.row.englishName : "暂未设置"
        );
      },
    },
    {
      title: this.L("Address"),
      key: "address",
      tooltip: true,
    },
    {
      title: this.L("PhoneNumber"),
      key: "phoneNumber",
      width: 120,
    },
    {
      title: this.L("RegionName"),
      key: "regionName",
      width: 150,
    },
    {
      title: this.L("DisplayOrder"),
      key: "displayOrder",
      width: 70,
      slot: "displayOrder",
    },
    {
      title: this.L("PreferentialCourt"),
      key: "isPreferential",
      width: 70,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isPreferential ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("CreationTime"),
      key: "creationTime",
      width: 100,
      render: (h: any, params: any) => {
        return h(
          "span",
          new Date(params.row.creationTime).toLocaleDateString()
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 80,
      align: "center",
      slot: "action",
    },
  ];
  async onChange(value, selectedData) {
    if (selectedData && selectedData.length > 0) {
      const a = selectedData.length - 1;
      this.pagerequest.regionId = selectedData[a].value;
    }
  }
  async created() {
    this.getpage();
  }
}
